<template>
  <div class="getpicpagea"> 当前页
    <font color="#f00000">{{currentPage}}</font>/{{totalPage}}共有 {{count}}条信息 每页{{pagesize}}条 
    <span @click="pre_page">上一页</span> | 
    <span @click="next_page">下一页</span> | 
    <a href="">尾页</a> 转到
    <select v-model="pageSelected" @change="goto_page">
      <option :value="index" v-for="index of totalPage" :key="index">{{index}}</option>
    </select>页
  </div>
</template>

<script>
  export default {
    name: "tPages",
    data(){
      return {
        pageSelected: 1,
      };
    },
    props: {
      currentPage: { type: Number, default: 1 },
      totalPage:{type: Number, default: 1},
      count:{type: Number, default: 1},
      pagesize:{type: Number, default: 10}
    },
    methods: {
      pre_page: function (event) {
        this.$emit('prepage');
      },
      next_page: function () {
        this.$emit('nextpage');
      },
      goto_page: function () {

        this.$emit('gotopage',this.pageSelected);
      }
  },
  }
</script>

<style lang="scss">
  /*--案例列表开始--*/
  .getpicpagea{ height:30px; line-height:30px;padding:3px 0 3px 0; text-align:center;}/*案例页码*/
</style>



// WEBPACK FOOTER //
// src/components/layout/pages.vue